<template>
    <modal :id="ref" :ref="ref" :closeProp="close" :title="title">
        <div v-if="!!error" class="alert alert-danger show" role="alert">
            <span class="alert-icon">
                <font-awesome-icon
                    :icon="['fad', 'exclamation']"
                ></font-awesome-icon>
            </span>

            <h3 class="alert-heading headline-font">Errore</h3>
            <ul v-if="typeof error === 'array' || typeof error === 'object'">
                <li
                    v-for="(value, key) in error"
                    :key="key"
                    v-html="value"
                ></li>
            </ul>
            <p v-else-if="typeof error === 'string'" v-html="error"></p>
        </div>

        <form :id="refForm" :ref="refForm">
            <div class="row">
                <datatable-form-cell
                    v-for="(value, col_index) in thead"
                    :key="col_index"
                    :colIndex="col_index"
                    :col="value"
                    :hideEmpty="hideEmpty"
                    :defaultValue="defaultValue(value)"
                ></datatable-form-cell>
            </div>
        </form>

        <template v-slot:footer>
            <btn
                type="success"
                :icon="['fad', 'check']"
                title="Salva"
                :action="submitForm"
            ></btn>
        </template>
    </modal>
</template>

<script>
export default {
    data: () => ({
        ref: "table",
        refForm: "",
        urlupdate: "",
        id: "",
        datas: {},
        error: null
    }),
    props: {
        urlstore: {
            type: String,
            default: "",
            required: false
        },
        thead: {
            type: [Array, Object],
            default: null,
            required: true
        }
    },
    computed: {
        title: function() {
            return !!this.urlupdate ? "Modifica" : "Crea";
        },
        hideEmpty: function() {
            return !this.urlupdate;
        }
    },
    methods: {
        close: function() {
            this.assignData({});
            this.urlupdate = "";
            this.error = null;
            this.id = "";

            this.$refs[this.ref].close();
        },
        open: function(data) {
            if (!!data && typeof data === "object") {
                if (!!data.urlupdate) this.urlupdate = data.urlupdate;
                if (!!data.datas) this.assignData(data.datas);
            } else if (!!data && Array.isArray(data)) {
                this.assignData(data);
            } else {
                this.assignData({});
            }

            this.$refs[this.ref].open();
        },
        getValue: function(key, defaultValue) {
            if (!!this.datas[key]) return this.datas[key];
            else if (!!defaultValue) return defaultValue;
            else return "";
        },
        getAction: function() {
            return !!this.id ? this.urlupdate : this.urlstore;
        },
        getMethod: function() {
            return !!this.id ? "PATCH" : "POST";
        },
        assignData: function(datas) {
            if (!datas) return false;

            if (!!Object.keys(datas).length) {
                this.datas = datas;
                if (!!datas.id) this.id = datas.id;
            } else {
                this.datas = {};
                this.id = "";
            }
        },
        submitForm: function() {
            this.error = null;

            return this.$root.request(
                this,
                this.getAction(),
                this.getMethod(),
                this.$root.getParamsFromForm(this.$refs[this.refForm]),
                this.submitFormCallback,
                this.errorFormCallback
            );
        },
        submitFormCallback: function(data) {
            this.$parent.refreshTable();

            let self = this;
            Vue.nextTick().then(function() {
                self.close();
            });
        },
        errorFormCallback: function({ response, message }) {
            if (!!response.data && !!response.data.error)
                this.error = response.data.error;
            else this.error = null;
        },
        defaultValue: function(col) {
            if (!!col.formData) return this.getValue(col.formData);
            else if (!!col.data) return this.getValue(col.data);

            return null;
        }
    },
    created: function() {
        this.refForm = this.ref + "DataForm";
    }
};
</script>
